import React from 'react';
import {Button, Select} from 'antd';
import {ClearOutlined} from '@ant-design/icons';

export interface FilterSelectGroup {
  key: string;
  label: string;
  options: {label: string; value: string}[];
  value: string[];
  onChange: (values: string[]) => void;
}

interface FilterBarInlineProps {
  // Group picker — lists every filter group; ticking one reveals its value select.
  groupOptions: {label: string; value: string}[];
  activeGroups: string[];
  onActiveGroupsChange: (keys: string[]) => void;
  groupsLabel?: string;
  // Value selects, one per active group.
  selects: FilterSelectGroup[];
  dateControl?: React.ReactNode;
  totalCount?: number;
  resultLabel?: string;
  activeCount?: number;
  clearLabel?: string;
  onClearAll?: () => void;
  extra?: React.ReactNode;
}

const barStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 8,
  padding: '8px 12px',
  backgroundColor: '#fff',
  flexWrap: 'wrap',
  flexShrink: 0
};

const clusterStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  flexWrap: 'wrap',
  minWidth: 0
};

const FilterBarInline: React.FC<FilterBarInlineProps> = ({
                                                           groupOptions,
                                                           activeGroups,
                                                           onActiveGroupsChange,
                                                           groupsLabel = 'Filters',
                                                           selects,
                                                           dateControl,
                                                           totalCount,
                                                           resultLabel,
                                                           activeCount = 0,
                                                           clearLabel = 'Clear',
                                                           onClearAll,
                                                           extra
                                                         }) => {
  return (
    <div style={barStyle}>
      <div style={clusterStyle}>
        <Select
          mode="multiple"
          allowClear
          size="medium"
          variant={"filled"}
          maxTagCount="responsive"
          style={{minWidth: 180}}
          placeholder={groupsLabel}
          options={groupOptions}
          value={activeGroups}
          onChange={(keys) => onActiveGroupsChange(keys as string[])}
        />

        {selects.map(group => (
          <Select
            key={group.key}
            allowClear
            variant={"filled"}
            showSearch
            optionFilterProp={"label"}
            size="medium"
            style={{minWidth: 150}}
            placeholder={group.label}
            options={group.options}
            value={group.value[0]}
            onChange={(value) => group.onChange(value ? [value as string] : [])}
          />
        ))}

        {dateControl}
      </div>

      <div style={clusterStyle}>
        {totalCount !== undefined && totalCount > 0 && (
          <span style={{fontSize: 12, color: '#707b91', whiteSpace: 'nowrap'}}>
            {totalCount.toLocaleString()} {resultLabel}
          </span>
        )}

        {activeCount > 0 && onClearAll && (
          <Button
            type="link"
            size="small"
            icon={<ClearOutlined/>}
            onClick={onClearAll}
            style={{padding: 0}}
          >
            {clearLabel}
          </Button>
        )}

        {extra}
      </div>
    </div>
  );
};

export default FilterBarInline;
export type {FilterBarInlineProps};
